import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
    income:{
        border:'7px solid rgba(0, 255, 0,0.5)',
        
    },
    expense:{
        border: '7px solid rgba( 255,0, 0,0.5)',
    },
}));